import { render, staticRenderFns } from "./homeMainMemberPart.vue?vue&type=template&id=2e49aaca&scoped=true"
import script from "./homeMainMemberPart.vue?vue&type=script&lang=js"
export * from "./homeMainMemberPart.vue?vue&type=script&lang=js"
import style0 from "./homeMainMemberPart.vue?vue&type=style&index=0&id=2e49aaca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e49aaca",
  null
  
)

export default component.exports